import './LoginBackdrop.css';

/**
 * Backdrop for the sign-in page's branding panel: two blurred teal lights
 * drifting slowly and shifting in brightness over a dark ground. Drawn in CSS, so there is nothing to
 * download, and it holds still for people who ask for reduced motion.
 */
export default function LoginBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden bg-slate-950" aria-hidden="true">
      <div className="login-glow-a absolute -left-[15%] top-[5%] aspect-square w-[70%] rounded-full bg-teal-500 blur-3xl" />
      <div className="login-glow-b absolute left-[40%] top-[30%] aspect-square w-[70%] rounded-full bg-cyan-700 blur-3xl" />
      {/* Darkens the edges so the logo and tagline stay readable */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950/70 via-transparent to-slate-950/80" />
    </div>
  );
}
